/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TaskInsert/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Assignee from './Assignee/index'
import Description from './Description/index'
import DocumentTemplate from './DocumentTemplate/index'
import React from 'react'
import Recipient from './Recipient/index'
import TaskBasket from './TaskBasket/index'
import Title from './Title/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TaskInsert({
  children,
  viewPath = "/DesignSystem/ManualAutomations/Content/Content/ActiveAction/TaskInsert"
  
}) {
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="xmedium"
 weight="semibold"
 marginBottom={dtSpaceM}
 marginTop={dtSpaceM}
 text="Create a new task"
/>
<Title
  viewPath={`${viewPath}/Title`}
/>
<Description
  viewPath={`${viewPath}/Description`}
/>
<div
  data-testid="TaskInsert.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TaskBasket
  viewPath={`${viewPath}/TaskBasket`}
/>
<DocumentTemplate
  viewPath={`${viewPath}/DocumentTemplate`}
/>
</div>
<div
  data-testid="TaskInsert.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<Recipient
  viewPath={`${viewPath}/Recipient`}
/>
<Assignee
  viewPath={`${viewPath}/Assignee`}
/>
</div>
{children}
</React.Fragment>)
}